import dayjs from 'dayjs'
import { FC, useMemo } from 'react'
import { useIntl } from 'react-intl'

import { KTSVG } from '@components/KTSVG'

type Props = {
  date?: string
}

const AppointmentAgendaEmpty: FC<Props> = ({ date }) => {
  const intl = useIntl()
  const formattedDate = useMemo(() => dayjs(date).defaultFormat(false), [date])

  return (
    <div className="d-flex flex-column align-items-center justify-content-center h-80">
      <KTSVG
        path="/media/icons/duotune/general/gen014.svg"
        className="svg-icon-4x svg-icon-gray-500 mb-3"
      />
      <div className="text-muted">
        {intl.formatMessage({ id: 'appointment.agenda.empty' })}
        {date ? ' at' : ''}
      </div>

      <div className="text-muted">{date ? `${formattedDate}` : ''}</div>
    </div>
  )
}

export { AppointmentAgendaEmpty }
